// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-enter-active[data-v-50e87614],.expand-leave-active[data-v-50e87614]{max-height:24rem;transition-property:all;transition-duration:.15s;transition-duration:.5s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.expand-enter[data-v-50e87614],.expand-leave-to[data-v-50e87614]{max-height:0}", ""]);
// Exports
module.exports = exports;
